//@ts-nocheck
import React from "react";
import { Modal } from "react-bootstrap";

const DeleteDialogueBox = (props) => {
  const {
    title = "Are you sure you want to delete this image?",
    open, close, cancel, deleteImage, ...rest } = props;
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };
  
  return (
    <>
      <Modal
        show={open}
        onHide={close}
        style={{backgroundColor: "rgba(255, 255, 255, 0.75)", zIndex:111111111 }}
      >
        <Modal.Body>
          
            <h6 style={{ fontWeight: "500", padding: "5px 0px 5px 0px" }}>
              {title}
            </h6>
            <div className="pl-sm-4 pt-1">
              <div className="row d-flex justify-content-end no-gutters  ">
                <div style={{ marginRight: "25px" }}>
                  <button
                    style={{ marginRight: "-12px" }}
                    className="btn btn-secondary btn-sm"
                    type="button"
                    onClick={cancel}
                  >
                   <i className="far fa-times-circle"></i> Cancel
                  </button>
                </div>
                {/* <Link to="/"> */}
                <div className="">
                  <button
                    style={{ marginRight: "10px" }}
                    className="btn btn-danger btn-sm "
                    type="button"
                    onClick={deleteImage}
                  >
                     <i className="fas fa-trash"></i> Delete
                  </button>
                </div>
                {/* </Link> */}
              </div>
            </div>
          
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteDialogueBox;
